
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("fEdqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $h1D2Q = parcelRequire("h1D2Q");
function $b6450320b11a5d30$var$_toConsumableArray(r) {
    return $b6450320b11a5d30$var$_arrayWithoutHoles(r) || $b6450320b11a5d30$var$_iterableToArray(r) || $b6450320b11a5d30$var$_unsupportedIterableToArray(r) || $b6450320b11a5d30$var$_nonIterableSpread();
}
function $b6450320b11a5d30$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b6450320b11a5d30$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b6450320b11a5d30$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b6450320b11a5d30$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b6450320b11a5d30$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $b6450320b11a5d30$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b6450320b11a5d30$var$_arrayLikeToArray(r);
}
function $b6450320b11a5d30$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
} // ====================================================================================
// CCM19 JavaScript Module
// ====================================================================================
// example code for the module
// <script
//   type="text/x-ccm-loader"
//   data-ccm-loader-group="d.vinci"
//   data-ccm-loader-src="https://..."
//   data-ccm-card="true"
//   data-ccm-ref=".dvinci-job-widget"
//   data-ccm-title="<p class='title'><strong>Stellenangebote via D.Vinci</strong></p>"
//   data-ccm-text="Um Ihnen unsere aktuellen Stellenangebote anzeigen zu können benötigen wir Ihre Zustimmung zur Datenverarbeitung durch D.Vinci.\nBitte Stimmen Sie diesen zu."
//   data-ccm-button="Cookie-Zustimmung ändern"
//   ></script>
// <div class="dvinci-job-widget" />
var $b6450320b11a5d30$var$BUTTON_CLASS = "btn";
var $b6450320b11a5d30$var$DEFAULT_TEXT = "Dieses Element ben\xf6tigt eine Zustimmung zur Datenverarbeitung.";
var $b6450320b11a5d30$var$DEFAULT_BUTTON_TEXT = "Cookie-Zustimmung \xe4ndern";
var $b6450320b11a5d30$var$isHTML = function isHTML(str) {
    return /<[a-z][\s\S]*>/i.test(str);
};
var $b6450320b11a5d30$var$createInformationCard = function createInformationCard(group, data) {
    var cardTitle = data.ccmTitle || group;
    var titleHTML = $b6450320b11a5d30$var$isHTML(cardTitle) ? cardTitle : "<h2>".concat(cardTitle, "</h2>");
    var cardText = data.ccmText || $b6450320b11a5d30$var$DEFAULT_TEXT;
    var textHTML = $b6450320b11a5d30$var$isHTML(cardText) ? cardText : "<p>".concat(cardText, "</p>");
    textHTML = textHTML.replace(/(\r\n|\r|\n|\\n)/g, "<br/>");
    var card = document.createElement("div");
    card.className = "ccm-info-card";
    card.setAttribute("ccm-data-group", group);
    card.innerHTML = "".concat(titleHTML).concat(textHTML);
    var button = document.createElement("button");
    button.className = "ccm-info-button ".concat($b6450320b11a5d30$var$BUTTON_CLASS);
    button.textContent = data.ccmButton || $b6450320b11a5d30$var$DEFAULT_BUTTON_TEXT;
    button.onclick = function() {
        return CCM.openControlPanel();
    };
    card.appendChild(button);
    return card;
};
var $b6450320b11a5d30$var$handleContentReload = function handleContentReload(data) {
    if (data.ccmCard !== "true") return;
    if (!data.ccmRef) return;
    var hasContent = Array.from(document.querySelectorAll(data.ccmRef)).some(function(el) {
        return el.innerHTML.trim() !== "";
    });
    if (hasContent) window.location.reload();
};
var $b6450320b11a5d30$var$processGroupElement = function processGroupElement(element, group, isAccepted) {
    if (!element || !element.dataset) return;
    if (element.dataset.ccmCard !== "true") return;
    var groupElements = document.querySelectorAll("[data-ccm-loader-group=\"".concat(group, "\"]"));
    if (groupElements.length === 0) return;
    groupElements.forEach(function(el) {
        if (el.dataset.ccmCard !== "true") return;
        var infoCard = el.parentElement.querySelector(".ccm-info-card");
        if (!infoCard) {
            var newInfoCard = $b6450320b11a5d30$var$createInformationCard(group, el.dataset);
            el.parentElement.appendChild(newInfoCard);
            infoCard = el.parentElement.querySelector(".ccm-info-card");
        }
        if (isAccepted) {
            infoCard.style.setProperty("display", "none");
            return;
        } else $b6450320b11a5d30$var$handleContentReload(el.dataset);
    });
};
var $b6450320b11a5d30$var$processEvent = function processEvent() {
    var embeddings = CCM.acceptedEmbeddings;
    if (!(embeddings !== null && embeddings !== void 0 && embeddings.length)) return;
    var groups = $b6450320b11a5d30$var$_toConsumableArray(new Set(Array.from(document.querySelectorAll("[data-ccm-loader-group]")).map(function(el) {
        return el.getAttribute("data-ccm-loader-group");
    }).filter(Boolean)));
    groups.forEach(function(group) {
        var groupElements = document.querySelectorAll("[data-ccm-loader-group=\"".concat(group, "\"]"));
        if (groupElements.length === 0) return;
        var normalizedGroup = group.trim().toLowerCase();
        var isAccepted = embeddings.some(function(e) {
            var name = e.name.trim().toLowerCase();
            return name.includes(normalizedGroup);
        });
        groupElements.forEach(function(el) {
            return $b6450320b11a5d30$var$processGroupElement(el, group, isAccepted);
        });
    });
};
var $b6450320b11a5d30$var$init = module.exports.init = function init() {
    (0, $h1D2Q.domReady)().then(function() {
        if (typeof CCM === "undefined") return;
        var hasGroups = document.querySelector("[data-ccm-loader-group]");
        if (!hasGroups) return;
        $b6450320b11a5d30$var$processEvent();
        [
            "ccm19WidgetLoaded",
            "ccm19WidgetClosed"
        ].forEach(function(event) {
            window.addEventListener(event, $b6450320b11a5d30$var$processEvent);
        });
    });
};

});
parcelRegister("h1D2Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.domReady = void 0;
var $c650d1302b554f6f$var$domReady = module.exports.domReady = function domReady() {
    return new Promise(function(resolve) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
};

});



//# sourceMappingURL=ccm19.module.258ff246.js.map
